var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$store.state.wechat),expression:"!$store.state.wechat"}],class:{
    notchHeader: _vm.hasNotch,
    header: true,
    xHeader: _vm.$store.state.iphonex,
    flexElement: true,
    weHeader: _vm.$store.state.wechat,
  }},[_c('span',{staticClass:"aside asideLeft",on:{"click":function($event){_vm.showBack ? _vm.$router.goBack() : ''}}},[_c('van-icon',{attrs:{"name":_vm.showBack ? 'arrow-left' : '',"size":"20px"}})],1),_vm._v(" "),_c('span',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"aside"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2149cbe8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = 3c3H
// module chunks = 2